export default __webpack_public_path__ + "maps-examples-draggable-views-thumbnail-480-99d8184b9eecc048cebdd4c72ddacdbf.webp";